import { render } from "./GastosView.vue?vue&type=template&id=758fab3f"
import script from "./GastosView.vue?vue&type=script&lang=js"
export * from "./GastosView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__